import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock, ArrowLeft } from "lucide-react";
const articles = [{
  id: 1,
  title: "זכויות סיעוד ביטוח לאומי: המדריך המלא",
  excerpt: "גלו אילו קצבאות מגיעות לכם בטיפול בדמנציה, שיקום לאחר אשפוז, וליווי בבתי חולים כמו איכילוב, שיבא ותל השומר.",
  date: "15 בינואר, 2024",
  readTime: "7 דקות קריאה",
  imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_rights_guide.png",
  slug: "/ProfessionalBlogPage/nursing-rights-guide"
}, {
  id: 2,
  title: "איך לבחור מטפל סיעודי שמתאים בדיוק לכם",
  excerpt: "צוות המטפלים שלנו מורכב מישראלים בלבד בתיווך רפואי מקצועי, המלווים אתכם בבתי חולים כמו אסותא ובילינסון ומבינים לעומק את צרכי המטופל.",
  date: "22 בדצמבר, 2023",
  readTime: "5 דקות קריאה",
  imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/choosing_caregiver.png",
  slug: "/ProfessionalBlogPage/choosing-caregiver"
}, {
  id: 3,
  title: "השגחה בבית חולים: כל מה צריך לדעת",
  excerpt: "זקוקים לשירותי השגחה בבית חולים? ליווי צמוד בשיבא, איכילוב, בילינסון ואסותא למצבי דמנציה, שיקום וסיוע רפואי על ידי מטפלים ישראלים מיומנים.",
  date: "10 בדצמבר, 2023",
  readTime: "6 דקות קריאה",
  imageUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hospital_supervision.png",
  slug: "/ProfessionalBlogPage/hospital-supervision"
}];
export default function WhatElseIsWorthKnowing() {
  return <section data-section-id="85092" id="מדריך-הזכויות-והסיעוד" className="py-16 md:py-24 bg-background text-foreground" dir="rtl">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-primary mb-4 tracking-tight">
            מדריך הזכויות והסיעוד
          </h2>
          <p className="text-lg md:text-xl font-default text-muted-foreground max-w-2xl mx-auto">
            כל המידע המקצועי, הטיפים והזכויות שמגיעות לכם במקום אחד. המומחים של סיעוד מיידי כאן בשבילכם עם כל התשובות.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, i) => <Card key={article.id} data-index={i} className="flex flex-col overflow-hidden border-border/60 shadow-sm hover:shadow-xl transition-all duration-500 bg-card group rounded-xl">
              <div className="aspect-[16/10] w-full overflow-hidden relative bg-muted">
                <img src={article.imageUrl} data-wvc-srcset={`${article.imageUrl}-wvc-srcset`} data-wvc-sizes={`${article.imageUrl}-wvc-sizes`} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              </div>
              
              <CardHeader className="flex-none pb-4">
                <div className="flex items-center gap-4 text-xs font-default text-muted-foreground mb-3">
                  <span className="flex items-center gap-1.5">
                    <SafeHydrate><Calendar className="size-3.5 text-secondary" /></SafeHydrate>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <Clock className="size-3.5 text-secondary" />
                    {article.readTime}
                  </span>
                </div>
                <CardTitle className="text-xl leading-tight font-default font-medium text-card-foreground group-hover:text-secondary transition-colors">
                  <Link to={article.slug} className="focus:outline-none">
                    <span className="absolute inset-0 z-10" aria-hidden="true" />
                    {article.title}
                  </Link>
                  <Link to="/HomePage" className="relative z-20 text-sm block mt-2 text-secondary font-bold hover:underline">
                    מטפל סיעודי
                  </Link>
                </CardTitle>
              </CardHeader>
              
              <CardContent className="flex-grow">
                <p className="text-muted-foreground font-default text-base leading-relaxed">
                  {article.excerpt}
                  {" "}
                  למידע נוסף על שירותי <Link to="#השגחה-בבית-חולים" className="text-secondary hover:underline font-bold"><span id="השגחה-בבית-חולים">השגחה בבית חולים</span></Link> וסיוע בתהליך <Link to="#טיפול-לאחר-אשפוז" className="text-secondary hover:underline"><span id="טיפול-לאחר-אשפוז">טיפול לאחר אשפוז</span></Link>, 
                  ניתן לבדוק את <Link to="/ProfessionalBlogPage" className="text-secondary hover:underline">זכויות סיעוד</Link> המגיעות לכם. 
                  אנו מספקים <Link to="/CaregiverServicePagesPage" className="text-secondary hover:underline"><Link to="#מטפל-סיעודי-בבית" className="inline"><span id="מטפל-סיעודי-בבית">מטפל סיעודי בבית</span></Link></Link>, 
                  {" "}<Link to="/NursingCareNowPage" className="text-secondary hover:underline"><Link to="#מטפל-סיעודי-פרטי" className="inline"><span id="מטפל-סיעודי-פרטי">מטפל סיעודי פרטי</span></Link></Link>, 
                  {" "}או מטפל סיעודי ברמת גן ובחיפה לזמינות מיידית.
                </p>
              </CardContent>
              
              <CardFooter className="flex-none pt-0">
                <span className="inline-flex items-center text-sm font-default font-semibold text-secondary group-hover:text-secondary/80 transition-colors">
                  קראו עוד
                  <ArrowLeft className="mr-2 size-4 transition-transform group-hover:-translate-x-1" />
                </span>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <Button asChild size="lg" className="rounded-lg px-10 py-6 text-lg font-default font-medium bg-primary text-primary-foreground shadow-md hover:shadow-xl hover:bg-primary/90 transition-all">
            <Link to="/ProfessionalBlogPage">
              לכל המאמרים המקצועיים בסיעוד רפואי
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}